import React, { createContext, ReactNode } from "react";

export type PageNavigator = (pageIndex: number) => void;

export const PageNavigationContext = createContext<PageNavigator>(() => {});

export const PageNavigationProvider: React.FC<{
	navigate: PageNavigator;
	children: ReactNode;
}> = ({ navigate, children }) => <PageNavigationContext.Provider value={navigate}>{children}</PageNavigationContext.Provider>;
